/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 17:19:01
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 17:28:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/slice/common.ts
 */
import { getStateTarget as getTarget } from 'src/tools/helper';
import { EnumReducers } from 'src/store/constants';
import { getSearchCondition as _getSearchCondition } from 'src/tools/selectors/search';

const reviewReducers = (reducers) => {
  return [EnumReducers.storeProductReview, ...reducers];
};
const reducerTarget = (state, reducers) => {
  return getTarget(state, reviewReducers(reducers));
};

const getSearchCondition = (reducer) => {
  return _getSearchCondition(reviewReducers([reducer]));
};

export { reducerTarget, getSearchCondition };
